import { createContext, useContext } from "react"
import { useParams } from "react-router-dom"
import { useDataCountDetail } from "../../utils"
import type { DataCountType } from "../../types"

type CountDetailContextType = {
  data: DataCountType | null
  isLoading: boolean
  refetchCountDetail: () => void
}

const CountDetailContext = createContext<CountDetailContextType | undefined>(undefined)

export function useCountDetailContext() {
  const context = useContext(CountDetailContext)
  if (!context) throw new Error("useCountDetailContext must be used within CountDetailProvider")
  return context
}

export function CountDetailProvider({ children }: { children: React.ReactNode }) {
  const { id } = useParams()
  const { data, isLoading, refetchCountDetail } = useDataCountDetail(id!)

  return (
    <CountDetailContext.Provider value={{ data, isLoading, refetchCountDetail }}>
      {children}
    </CountDetailContext.Provider>
  )
}

export function useOptionalCountDetailContext() {
  return useContext(CountDetailContext) ?? null
}
